import { render, staticRenderFns } from "./UploadsSideMenu.vue?vue&type=template&id=650d3c1a&scoped=true&"
import script from "./UploadsSideMenu.vue?vue&type=script&lang=js&"
export * from "./UploadsSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./UploadsSideMenu.vue?vue&type=style&index=0&id=650d3c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d3c1a",
  null
  
)

export default component.exports